import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatProgressBarModule, MatButtonModule,
     MatIconModule, MatInputModule,
      MatAutocompleteModule, MatSelectModule, MatCardModule } from '@angular/material';
import { AutocompleteComponent } from './autocomplete.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatCardModule,
    MatAutocompleteModule,
    MatIconModule,
    MatProgressBarModule,
    TranslateModule
  ],
  declarations: [AutocompleteComponent],
  exports: [AutocompleteComponent]
})
export class NgMatAutocompleteModule { }
